// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "i[data-v-0d626f74]{cursor:pointer;font-size:2rem;line-height:38px;text-align:center;width:38px}\n", ""]);
// Exports
module.exports = exports;
